import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import { AllDealStats, GetAllDealStatsPayload } from '../../../models/deal';

export const getAllDealStatsAction = createAction(
  ActionTypes.GET_ALL_DEAL_STATS,
  props<{ refresh?: boolean, payload: GetAllDealStatsPayload }>()
);

export const getAllDealStatsSuccessAction = createAction(
  ActionTypes.GET_ALL_DEAL_STATS_SUCCESS,
  props<{ data: AllDealStats | undefined }>()
);

export const getAllDealStatsFailureAction = createAction(
  ActionTypes.GET_ALL_DEAL_STATS_FAILURE,
  props<{ error: unknown }>()
);

export const clearAllDealStatsAction = createAction(
  ActionTypes.GET_ALL_DEAL_STATS_FAILURE,
);
